export const constants = {
  CLASSNAME_PREFIX: 'centivo--select',
}
